export type CategoryId =
  | 'all'
  | 'engine-internal'
  | 'engine-block'
  | 'induction'
  | 'valve-cover'
  | 'driveline'
  | 'body-sheet'
  | 'interior'
  | 'exhaust'
  | 'fasteners';

export interface Category {
  id: CategoryId;
  label: string;
  iconId?: string;
}

export const CATEGORIES: readonly Category[] = [
  { id: 'all', label: 'All Parts' },
  { id: 'engine-internal', label: 'Engine Internals', iconId: 'i-piston' },
  { id: 'engine-block', label: 'Block & Heads', iconId: 'i-block' },
  { id: 'induction', label: 'Fuel & Induction', iconId: 'i-intake' },
  { id: 'valve-cover', label: 'Valve Covers', iconId: 'i-cover' },
  { id: 'driveline', label: 'Driveline', iconId: 'i-crank' },
  { id: 'body-sheet', label: 'Body / Sheet Metal', iconId: 'i-fender' },
  { id: 'interior', label: 'Interior', iconId: 'i-interior' },
  { id: 'exhaust', label: 'Exhaust', iconId: 'i-exhaust' },
  { id: 'fasteners', label: 'Fasteners', iconId: 'i-fastener' },
];

export function categoryLabel(id: string): string {
  const cat = CATEGORIES.find((c) => c.id === id);
  return cat?.label ?? id;
}

export const NON_ALL_CATEGORIES = CATEGORIES.filter((c) => c.id !== 'all');
